<script setup>
import {User} from '@/paks/mgr-models'
import {onMounted, reactive, ref} from 'vue'
import {Progress, State, can} from '@/paks/vu-app'
import UserEdit from './UserEdit.vue'

const page = reactive({
    canAdd: null,
    fields: [
        {name: 'edit', icon: '$edit', desktop: true, width: '5%'}, 
        {name: 'email', width: '50%'}, 
        {name: 'role', width: '10%'}, 
        {name: 'state', desktop: true}
    ],
    showEdit: false,
    user: {},
    users: null,
})

//  Component references
const table = ref(null)

onMounted(() => {
    load()
})

async function load(args) {
    //  Fetch live incase a users has accepted the invite
    Progress.start('repeat')
    page.canAdd = can('admin') && !State.auth.account.suspended
    page.users = await User.find({}, {refresh: true})
    Progress.stop()
}

async function clicked({action, item, items, column}) {
    if (action == 'add') {
        editUser({})
    } else if (action == 'edit') {
        for (let user of items) {
            editUser(user)
            break
        }
    } else if (action == 'cell') {
        editUser(item)
    }
}

async function editUser(user) {
    page.showEdit = user ? true : false
    page.user = user || {}
    if (!user) {
        await load()
    }
}
</script>

<template>
    <div class="page user-list">
        <vu-table
            name="user-list"
            nodata="Fetching users..."
            options="dynamic,filter,refilter,toolbar"
            ref="table"
            :data="page.users"
            :fields="page.fields"
            :select="{actions: {Add: 0, Edit: 1, Delete: 2}, multi: true, property: 'select'}"
            @click="clicked"
            @reload="load">
            <template v-slot:more="props">
                <v-btn color="primary" class="mr-2" v-if="can('admin')" :disabled="!page.canAdd" @click="editUser({})">
                    Invite User
                </v-btn>
            </template>
            <template v-slot:table-col-edit="props">
                <v-icon icon="$edit" size="24" @click.stop="editUser(props.item)" />
            </template>
        </vu-table>
        <vu-panel v-model="page.showEdit" @close="editUser" :widths="['600px']">
            <UserEdit :id="page.user.id" @input="editUser" />
        </vu-panel>
    </div>
</template>